"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = exports.Hierarchy = exports.Copc = exports.Constants = void 0;
exports.Constants = __importStar(require("./constants"));
var copc_1 = require("./copc");
Object.defineProperty(exports, "Copc", { enumerable: true, get: function () { return copc_1.Copc; } });
var hierarchy_1 = require("./hierarchy");
Object.defineProperty(exports, "Hierarchy", { enumerable: true, get: function () { return hierarchy_1.Hierarchy; } });
var info_1 = require("./info");
Object.defineProperty(exports, "Info", { enumerable: true, get: function () { return info_1.Info; } });
